import { redirect } from "react-router-dom";
import { authService } from "@/services/auth/authService";
import { RoleEnum } from "@/types/auth/roleEnum";

export const loginAction = async ({ request }: { request: Request }) => {
  const formData = await request.formData();
  try {
    const result = await authService.loginAndSetUser(
      formData.get("username") as string,
      formData.get("password") as string,
    );
    if (result.roles.includes(RoleEnum.Admin)) {
      return redirect("/admin-panel");
    }
    if (result.roles.includes(RoleEnum.Lecturer)) {
      return redirect("/lecturer");
    }
    if (result.roles.includes(RoleEnum.Student)) {
      return redirect("/homepage");
    }
  } catch (err) {
    return err;
  }
};
